<script lang="ts">
import { defineComponent } from 'vue';

import { makeTagProps, makeTextProps } from '../../composable';

export const componentName = 'CdsInputDescription';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTextProps(),
    ...makeTagProps()
  }
});
</script>

<template>
  <component :is="tag" class="cds-input__description">
    {{ text }}
    <slot />
  </component>
</template>
